var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual-full', {
    attrs: {
      "bg": "/images/sub/visual/sv4-3.jpg"
    }
  }, [_c('div', {
    staticClass: "text-ani-wrap mb-30 mb-lg-54"
  }, [_c('div', {
    staticClass: "text-ani mb-14 mb-lg-28"
  }, [_c('h2', {
    staticClass: "font-weight-bold font-size-40 font-size-md-54 font-size-lg-80 line-height-1"
  }, [_vm._v(" Fundraiser ")])]), _c('div', {
    staticClass: "text-ani"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold line-height-1"
  }, [_vm._v(" 펀드레이저 ")])])]), _c('p', {
    staticClass: "tit-txt color-grey-d"
  }, [_vm._v(" NGO의 가치와 의미를 알리는 "), _c('br'), _vm._v(" 기금 모금 활동가 ")])]), _c('section', {
    staticClass: "section bg-grey"
  }, [_c('v-container', [_c('div', {
    staticClass: "video-wrap mb-30 mb-lg-54"
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/SWy8xSq9-o8",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })]), _c('div', {
    staticClass: "mb-30 mb-lg-54"
  }, [_c('p', {
    staticClass: "tit-txt text-center mb-8 mb-lg-24"
  }, [_vm._v(" 펀드레이저는 개인과 단체의 기부가 이뤄지도록 기획하고 독려하는 기금모금 활동 전문가로서 공공의 가치를 일깨우고 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 사회의 긍정적인 변화에 관심을 갖도록 하며 후원자를 유치합니다. 사회의 성숙과 함께 건강한 기부문화가 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 활성화될수록 전문 펀드레이저의 수요와 필요성이 증가하고 있습니다. ")]), _c('p', {
    staticClass: "tit-txt text-center mb-8 mb-lg-24"
  }, [_vm._v(" 세일즈웍스는 NGO 단체를 전문적으로 담당하는 브랜드, 서포트웍스를 운영하고 있습니다. ")])]), _c('div', {
    staticClass: "video-wrap mb-30 mb-lg-54"
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/tPvczyeH7YI",
      "title": "YouTube video player",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "mx-auto mb-10 mb-md-0",
    attrs: {
      "cols": "7",
      "sm": "5",
      "md": "3",
      "data-aos": "fade-right"
    }
  }, [_c('div', {
    staticClass: "w-100 h-100 d-md-flex align-center pr-md-12 pr-lg-24"
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/supportworks-ci.svg"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "9",
      "data-aos": "fade-left"
    }
  }, [_c('div', {
    staticClass: "w-100 h-100 pl-md-24 pl-lg-60 border-md-start border-color-light"
  }, [_c('p', {
    staticClass: "page-text--sm color-grey-7 mb-14 mb-lg-26"
  }, [_c('strong', {
    staticClass: "font-weight-bold color-black"
  }, [_vm._v("서포트웍스는 "), _c('span', {
    staticClass: "color-secondary"
  }, [_vm._v("매년 약 3만명")]), _vm._v("의 후원자를 NGO 단체와 연결하고 있습니다.")]), _vm._v(" "), _c('br'), _vm._v(" 서포트웍스의 펀드레이저는 검증된 국내외 NGO 단체와 함께하고, 나아가 다른 펀드레이저의 멘토가 되어 트레이닝 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 스킬, 매니징 역량을 키우며 커리어 확장이 가능합니다. ")]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 color-grey-9 mb-20 mb-lg-30"
  }, [_vm._v(" * 서포트웍스 홈페이지를 방문하시면 펀드레이저에 대해 더 자세히 확인하실 수 있습니다. ")]), _c('arrow-btn', {
    attrs: {
      "tit": "서포트웍스 홈페이지",
      "color": "secondary",
      "link": "https://www.supportworks.kr/",
      "type": "href"
    }
  })], 1)])], 1)], 1)], 1), _c('section', {
    staticClass: "section bg-grey section-top-image",
    staticStyle: {
      "background-image": "url(/images/sub/recruitment/fundlaser/s2-bg.jpg)",
      "background-position": "right 25% top"
    }
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-left"
  }, [_c('h3', {
    staticClass: "tit color-white font-weight-bold"
  }, [_vm._v(" 왜 "), _c('br'), _vm._v(" 서포트웍스와 "), _c('br'), _vm._v(" 함께할까요? ")])]), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/recruitment/fundlaser/s2-img1.jpg",
      "tit": "NGO의 가치 실현과 진정한 보람",
      "titWidth": "w-xl-40"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-xl-18 line-height-15 color-grey-7"
  }, [_vm._v(" NGO 단체의 얼굴이 되어 보다 나은 세상을 만드는 역할을 합니다. 서포트웍스는 올바른 가치를 옹호하고 공공성을 지향하는 국내외 NGO 단체와 일해왔습니다. "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 구호활동에 대한 깊이 있는 이해와 진심, 그리고 책임감을 가진 펀드레이저로서 공공의 가치를 실현하는 것에 큰 자부심을 느낄 수 있습니다. ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/recruitment/fundlaser/s2-img2.jpg",
      "tit": "다양한 사람들과 깊이 있는 소통",
      "titWidth": "w-xl-50"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-xl-18 line-height-15 color-grey-7"
  }, [_vm._v(" 사람들과 소통하며 윤리와 신뢰를 기반으로 마음을 움직일 수 있어야 합니다. 경청하는 자세, 이해력, 공감력을 갖춘 펀드레이저를 통해 NGO 캠페인을 접한 시민들의 인식과 참여 증대는 사회 문제 해결의 출발점이 됩니다. ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/recruitment/fundlaser/s2-img3.jpg",
      "tit": "전문가로 성장하는 체계적 교육 시스템",
      "titWidth": "w-xl-50"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-xl-18 line-height-15 color-grey-7"
  }, [_vm._v(" 전문 교육 시스템과 1:1 맞춤 트레이닝으로 인성과 실력을 갖춘 전문 펀드레이저를 양성합니다. 정기 세미나, 해외 워크숍, NGO 단체의 교육 및 온라인 교육 프로그램 등 전문성을 위한 다방면의 교육을 지원합니다. 경력과 무관하게 진정성과 열정을 가진 인재라면 전문 펀드레이저로 성장 가능합니다. ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/recruitment/fundlaser/s2-img4.jpg",
      "tit": "자율적 시간 관리 & 정당한 보상",
      "titWidth": "w-xl-62"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-xl-18 line-height-15 color-grey-7"
  }, [_vm._v(" 펀드레이저는 열정과 헌신, 확고한 윤리관이 필요한 전문 직업입니다. 공익을 추구하는 일이니만큼 지속성과 성취감이 중요합니다. 프리랜서 형태로 일하며 노력에 대한 정당한 보상을 받습니다. 역량과 환경에 맞게 자유롭게 시간을 관리하며 자기 주도적으로 일할 수 있습니다. ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/recruitment/fundlaser/s2-img5.jpg",
      "tit": "다양한 커리어 확대 지원",
      "titWidth": "w-xl-50"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-xl-18 line-height-15 color-grey-7"
  }, [_vm._v(" 국내외 다양한 NGO 단체를 깊이 있게 경험하면서 전문 직업인 펀드레이저로서의 커리어를 쌓게 됩니다. "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 본인이 추구하는 방향에 따라 트레이너로 성장하거나, 팀을 운영하며 커리어를 확장하고 싶다면 서포트웍스의 다양한 지원을 받을 수 있습니다. ")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('image-on', {
    attrs: {
      "bg": "/images/sub/recruitment/fundlaser/s2-img6.jpg",
      "tit": "사람 중심의 수평적인 문화",
      "titWidth": "w-xl-50"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-xl-18 line-height-15 color-grey-7"
  }, [_vm._v(" 서포트웍스는 서로의 성장을 응원하고 이끌어주는 사람 중심의 문화로 수평적이고 열린 소통을 지향합니다. "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 사람과 사람을 이어주는 따뜻한 직업인 펀드레이저가 즐겁게 일할 수 있는 기업 문화와 환경이 조성되어 있습니다. ")])])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v(" 홍보채널 ")]), _c('p', {
    staticClass: "tit-txt"
  }, [_vm._v(" 전국 지점을 바탕으로 다양한 채널에서 캠페인 활동이 가능합니다. ")])]), _c('v-row', {
    staticClass: "text-center",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mb-20 mb-sm-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-img', {
    staticClass: "w-100 mb-16 mb-lg-30",
    attrs: {
      "src": "/images/sub/recruitment/fundlaser/s3-img1.jpg"
    }
  }), _c('h5', {
    staticClass: "tit-txt font-weight-bold color-secondary mb-2 mb-lg-0",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" 대중 캠페인 ")]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 line-height-14 color-grey-7 mb-8 mb-lg-16",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 인구밀집지역 ")]), _c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 상업지구, 번화가와 같이 유동인구가 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 많은 지역에서 캠페인을 진행하며 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" NGO 단체를 알리고 후원자를 개발 ")])], 1), _c('v-col', {
    staticClass: "mb-20 mb-sm-0",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-img', {
    staticClass: "w-100 mb-16 mb-lg-30",
    attrs: {
      "src": "/images/sub/recruitment/fundlaser/s3-img2.jpg"
    }
  }), _c('h5', {
    staticClass: "tit-txt font-weight-bold color-secondary mb-2 mb-lg-0",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" 이벤트 행사 ")]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 line-height-14 color-grey-7 mb-8 mb-lg-16",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 축제, 행사, 쇼핑몰, 백화점 등 ")]), _c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" NGO 캠페인을 효과적으로 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 전달할 수 있는 이벤트 장소에서 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 캠페인 진행 ")])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-img', {
    staticClass: "w-100 mb-16 mb-lg-30",
    attrs: {
      "src": "/images/sub/recruitment/fundlaser/s3-img3.jpg"
    }
  }), _c('h5', {
    staticClass: "tit-txt font-weight-bold color-secondary mb-2 mb-lg-0",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_vm._v(" B2B / B2C ")]), _c('p', {
    staticClass: "font-size-12 font-size-lg-16 line-height-14 color-grey-7 mb-8 mb-lg-16",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 일반 기업 및 공공기관 ")]), _c('p', {
    staticClass: "page-text--sm"
  }, [_vm._v(" 오피스 밀집 지역 대상으로 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 밀도 있게 캠페인을 진행하여 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" NGO 단체 홍보 ")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }